import React from 'react';
import './ChartsDashboard.css';
import { Col, Divider, Row, Typography } from 'antd';

const { Text } = Typography;

interface Props {
  t: any,
  productTypesCount: {
    type1: {
      total: number
    },
    type2: {
      total: number
    },
    type3: {
      total: number
    },
    type4: {
      total: number
    }
  }
}

export const TotalSensors = ({ t, productTypesCount }: Props) => {
  const totalSensors = productTypesCount.type1?.total +
        productTypesCount.type2?.total +
        productTypesCount.type3?.total +
        productTypesCount.type4?.total;
  return <>
        <div className='titleBox'>
            <Text className='titleBlackBox' >{`${t('GENERAL_INFO')}`}</Text>
        </div>
        <div className='boxActiveSensors'>
            <Row justify='center' style={{ marginTop: 10, height: 130 }}>
                <Col span={24}>
                    <Row justify='center' style={{ height: 40, paddingTop: 35 }}>
                        <Col span={4} ><Text className='title' >{`${t('TOTAL_SENSORS')}`}</Text><br></br>
                            <Text className='value' strong>{totalSensors}
                            </Text>
                        </Col>
                        <Divider type='vertical' className='divider'></Divider>
                        <Col span={4}><Text className='title' > {`${t('TYPE')} 1`}</Text><br></br>
                            <Text className='value' strong>
                                {productTypesCount.type1?.total}
                            </Text>
                        </Col>
                        <Divider type='vertical' className='divider'></Divider>
                        <Col span={4}><Text className='title' >{`${t('TYPE')} 2`}</Text><br></br>
                            <Text className='value' strong>
                                {productTypesCount.type2?.total}
                            </Text>
                        </Col>
                        <Divider type='vertical' className='divider'></Divider>
                        <Col span={4}><Text className='title' >{`${t('TYPE')} 3`}</Text><br></br>
                            <Text className='value' strong> {productTypesCount.type3?.total}
                            </Text>
                        </Col>
                        <Divider type='vertical' className='divider'></Divider>
                        <Col span={4}><Text className='title' >{`${t('TYPE')} 4`}</Text><br></br>
                            <Text className='value' strong style={{ marginLeft: 15 }}> {productTypesCount.type4?.total}
                            </Text>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    </>;
};